import { extendTheme } from '@chakra-ui/react';
import { theme as udsTheme } from '@udacity/chakra-uds-theme';

export const theme = extendTheme(udsTheme, {
  colors: {
    colorTag: {
      // These colors are not available in @udacity/chakra-uds-theme yet.
      purple: { bg: '#F5EEFF', text: '#9759FA' },
      green: { bg: '#E9F8F1', text: '#246C52' },
      greenDark: { bg: '#C8EEDC', text: '#246C52' },
    },
  },
  styles: {
    global: {
      a: {
        color: 'blue.500',
        textDecoration: 'none',
      },
      // Needed to see the cursor when adding a code review comment
      '.ͼ4 .cm-line ::selection': {
        backgroundColor: '#6199ff2f !important;',
      },
    },
  },
});
